import CONSTANTS from "./constants";
import BaseHttpHandler from "./utilities/baseHttpHandler";

// Gets a custom value
async function getCustomValue(key) {
    try {
        let instance = await BaseHttpHandler.getInstance();

        const response = await instance.get(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.CUSTOM_VALUE + key,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

        return response.data;
    } catch (e) {
        // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        throw e;
    }
}
// Sets a custom value
async function setCustomValue(key, value) {
    try {
        let instance = await BaseHttpHandler.getInstance();
        const data = {
            key,
            value,
        }
        const response = await instance.post(
            CONSTANTS.API_CONSTANTS.ENDPOINTS.CUSTOM_VALUE,
            data,
            {
                cancelToken: BaseHttpHandler.getTimedCancelToken().token,
            }
        );

        return response.data;
    } catch (e) {
        // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
        console.log(e);
        throw e;
    }
}

export default {
    getCustomValue,
    setCustomValue,
};
